<div class="interventi-container">
  <!-- Header della pagina -->
  <div class="interventi-header">
    <div class="title-container" [ngClass]="{'title-compact': !!filtroRichiestaId}">
      <span class="material-icons title-icon" [ngClass]="{'icon-compact': !!filtroRichiestaId}" style="vertical-align: middle; margin-right: 8px; color: #166F72;">construction</span>
      <h1 class="page-title" [ngClass]="{'title-compact': !!filtroRichiestaId}" [innerHTML]="titoloInterventi"></h1>
      <div *ngIf="filtroCodiceScheda" class="codice-scheda-badge" style="background-color: #f5f5f5; padding: 0.15rem 0.5rem; border-radius: 4px; margin-left: 0.2rem;">
        <span class="codice-scheda-value" style="font-weight: bold; color: #3a6e75;">{{ filtroCodiceScheda }}</span>
      </div>
    </div>

    <div class="actions-container">
      <!-- Area Ricerca e Filtri Inline - TUTTO SULLA STESSA RIGA -->
      <div class="search-and-filters-container">
        <!-- Campo di ricerca -->
        <div class="custom-search-input">
          <i class="pi pi-search search-icon" [ngClass]="{'hidden': filtroTestoGlobale.length > 0}"></i>
          <input
            type="text"
            pInputText
            [(ngModel)]="filtroTestoGlobale"
            (input)="onFiltroGlobaleChange($event)"
            placeholder="Cerca interventi..."
            class="search-input"
            [ngClass]="{'has-text': filtroTestoGlobale.length > 0}"
          />
          <i class="pi pi-times clear-icon" *ngIf="filtroTestoGlobale.length > 0" (click)="pulisciFiltroGlobale()" style="cursor: pointer;"></i>
        </div>

        <!-- Filtri sulla stessa riga -->
        <div class="inline-filters">
          <!-- Filtro Anno -->
          <div class="filter-item anno-filter">
            <label class="filter-label">
              <i class="pi pi-calendar filter-icon"></i>
              Anno
            </label>
            <p-dropdown
              [options]="richiesteConRimuovi"
              [(ngModel)]="richiestaSelezionata"
              [optionLabel]="'anno'"
              (onChange)="onAnnoChange($event)"
              placeholder="Anno"
              [showClear]="false"
              styleClass="compact-dropdown anno-dropdown"
              appendTo="body"
              [filter]="false"
              [disabled]="!!filtroRichiestaId">
              <ng-template let-richiesta pTemplate="item">
                <!-- Opzione speciale "Tutti gli anni" -->
                <div *ngIf="richiesta.isRemoveOption || richiesta.id === 'remove-filter'"
                     class="reset-filter-option"
                     [ngStyle]="{
                       'font-style': 'italic',
                       'color': '#64748b',
                       'font-weight': '600',
                       'font-size': '0.75rem'
                     }">
                  <span style="font-style: italic; color: #64748b; font-weight: 600; font-size: 0.75rem;">{{ richiesta.anno }}</span>
                </div>
                <!-- Opzioni normali anni -->
                <span *ngIf="isAnnoValido(richiesta)"
                      class="badge dropdown-item-badge"
                      [ngStyle]="{
                        'background-color': getColoreAnno(richiesta.anno),
                        'color': '#ffffff',
                        'padding': '4px 8px',
                        'border-radius': '4px',
                        'font-weight': 'bold',
                        'display': 'block',
                        'text-align': 'left',
                        'width': 'fit-content',
                        'margin': '0',
                        'font-size': '0.85rem'
                      }">
                  {{ richiesta.anno }}
                </span>
              </ng-template>
              <ng-template let-richiesta pTemplate="selectedItem">
                <!-- Valore selezionato quando è presente un anno specifico -->
                <span *ngIf="richiesta && isAnnoValido(richiesta)"
                      class="badge selected-item-badge"
                      [ngStyle]="{
                        'background-color': getColoreAnno(richiesta.anno),
                        'color': '#ffffff',
                        'padding': '2px 6px',
                        'border-radius': '3px',
                        'font-weight': 'bold',
                        'font-size': '0.7rem'
                      }">
                  {{ richiesta.anno }}
                </span>
                <!-- Testo mostrato quando è selezionato 'Tutti gli anni' (filtro anno rimosso) -->
                <span *ngIf="!richiesta || !isAnnoValido(richiesta)"
                      style="color: #64748b; font-size: 0.875rem; font-style: italic;">
                  Tutti gli anni
                </span>
              </ng-template>
            </p-dropdown>
          </div>

          <!-- Filtro Stato -->
          <div class="filter-item stato-filter">
            <label class="filter-label">
              <i class="pi pi-flag filter-icon"></i>
              Stato
            </label>
            <p-dropdown
              [options]="statiInterventoConRimuovi"
              [(ngModel)]="statoSelezionato"
              optionLabel="descrizione"
              (onChange)="onStatoChange($event)"
              placeholder="Tutti gli stati"
              [showClear]="false"
              styleClass="compact-dropdown stato-dropdown"
              appendTo="body"
              [filter]="false">
              <ng-template let-stato pTemplate="item">
                <!-- Opzione speciale "Tutti gli stati" -->
                <div *ngIf="stato.isRemoveOption || stato.id === 'remove-filter'"
                     class="reset-filter-option"
                     [ngStyle]="{
                       'font-style': 'italic',
                       'color': '#64748b',
                       'font-weight': '600',
                       'font-size': '0.75rem'
                     }">
                  <span style="font-style: italic; color: #64748b; font-weight: 600; font-size: 0.75rem;">{{ stato.descrizione }}</span>
                </div>
                <!-- Opzioni normali stati -->
                <span *ngIf="isStatoValido(stato)" style="font-size: 0.75rem;">
                  {{ stato.descrizione }}
                </span>
              </ng-template>
            </p-dropdown>
          </div>

          <!-- Filtro per mostrare/nascondere interventi di altri enti quando si arriva da una richiesta -->
          <div *ngIf="isAdminOrUmvs && ((filtroRichiestaId && enteIdRichiesta) || enteIdRichiesta)" class="filter-item ente-richiesta-filter">
            <label class="filter-label ente-checkbox-label-text">SOLO ENTE RICHIESTA</label>
            <div class="ente-toggle-wrapper">
              <p-inputSwitch
                [(ngModel)]="mostraSoloInterventiEnteRichiesta"
                (onChange)="onToggleFiltroEnteRichiesta()"
                inputId="filtroEnteRichiesta">
              </p-inputSwitch>
            </div>
          </div>

          <!-- Reset Filtri -->
          <button
            *ngIf="filtriAttivi"
            pButton
            type="button"
            icon="pi pi-filter-slash"
            class="p-button-rounded p-button-text p-button-sm reset-filters-btn"
            (click)="azzeraTuttiFiltri()"
            pTooltip="Rimuovi tutti i filtri"
            tooltipPosition="top">
          </button>
        </div>
      </div>

      <!-- Container per i pulsanti di azione -->
      <div class="action-buttons-container">
        <button class="action-button"
          style="background-color: #a0cccc; color: #333; border: 1px solid #A0D6C1; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 6px;"
              (click)="aggiungiIntervento()"
              [disabled]="!checkIfCanAddIntervento()"
              [pTooltip]="checkIfCanAddIntervento() ? 'Aggiungi intervento' : 'Non puoi aggiungere interventi a questa richiesta'">
            <span class="material-icons">add</span>
            Aggiungi
        </button>
        <button [disabled]="!interventiCaricati" class="action-button" (click)="aggiornaInterventi()"
        style="background-color: #F8E9A1; color: #333; border: 1px solid #EBDC8D; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 6px;"
          [pTooltip]="interventiCaricati ? 'Ricarica elenco interventi' : 'Disponibile al termine del caricamento'"
          tooltipPosition="top">
          <span class="material-icons">refresh</span>
            Aggiorna
        </button>
        <button [disabled]="!interventiCaricati" class="action-button" (click)="scaricaReportInterventi()"
          style="background-color: #C7CEEA; color: #333; border: 1px solid #B2BCDC; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 6px;"
          [pTooltip]="interventiCaricati ? 'Esporta elenco interventi in Excel' : 'Disponibile al termine del caricamento'"
          tooltipPosition="top">
          <span class="material-icons">download</span>
            Esporta
        </button>
      </div>
    </div>
  </div>

  <!-- Contenuto principale -->
  <div class="interventi-content">
    <!-- TabView per ente esecutore o admin/umvs (tabella + mappa) -->
    <p-tabView [(activeIndex)]="activeTabIndex" styleClass="interventi-tabs" (onChange)="onTabChange($event)">
    <!-- Tab Interventi -->
    <p-tabPanel header="Lista" leftIcon="pi pi-table">
      <!-- Loader mentre vengono caricate gli interventi -->
      <div *ngIf="!interventiCaricati" class="loading-container">
        <div class="spinner"></div>
        <p>Caricamento interventi in corso...</p>
      </div>

      <!-- Lista degli interventi con p-table -->
      <div *ngIf="interventi.length > 0" class="interventi-list">
          <!-- Toggle per filtrare interventi -->
          <div *ngIf="isEnteEsecutore" class="filter-toggle-container" style="margin-bottom: 1rem; display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem; background: #f8f9fa; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
            <div class="toggle-switch" style="margin: 0;">
              <input type="checkbox" id="toggleFilter" [(ngModel)]="showOnlyMyInterventi" (change)="onToggleFilter()" class="toggle-input">
              <label for="toggleFilter" class="toggle-label">
                <span class="toggle-inner"></span>
                <span class="toggle-switch"></span>
              </label>
            </div>
            <span style="font-size: 14px; color: #495057; font-weight: 500;">Escludi gli interventi di altri enti</span>
          </div>

          <!-- Messaggio se non ci sono interventi -->
          <div *ngIf="interventi.length === 0" class="empty-state">
            <span class="material-icons">search_off</span>
            <h3>Nessun intervento trovato</h3>
          </div>

          <!-- PrimeNG Table -->
          <p-table
            *ngIf="interventiCaricati && interventi.length > 0"
            #dt
            [value]="interventi"
            [columns]="cols"
            [paginator]="true"
            [rows]="10"
            [rowsPerPageOptions]="[10,50,100,200]"
            styleClass="p-datatable-sm p-datatable-gridlines"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Interventi da {first} a {last} di {totalRecords}"
            [globalFilterFields]="['codice', 'richiesta.enteEsecutore.label', 'richiesta.anno', 'importoRichiesto','scheda.comune.denominazione', 'scheda.bacino.denominazione', 'scheda.vecchioCodiceUmvs', 'scheda.codice', 'priorita']"
            [sortMode]="'multiple'"
            [multiSortMeta]="[{field: 'richiesta.anno', order: -1}, {field: 'importoRichiesto', order: 1}]"
            [showInitialSortBadge]="false"
            responsiveLayout="stack"
            [rowHover]="true"
            [loading]="!interventiCaricati"
            [style]="{'margin-bottom': '20px', 'table-layout': 'fixed'}"
            (onFilter)="onFilter($event)"
            >

            <!-- Intestazioni delle colonne -->
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 2%">Azioni</th>
                <th style="width: 3%" pSortableColumn="richiesta.anno">
                  <div style="display: flex; justify-content: center; align-items: center; gap: 4px;">
                    <span>Anno</span>
                    <p-sortIcon field="richiesta.anno"></p-sortIcon>
                  </div>
                </th>
                <th style="width: 6%;" style="text-align: center;" >Scheda</th>
                <th style="width: 7%" pSortableColumn="scheda.vecchioCodiceUmvs">
                  <div style="display: flex; justify-content: center; align-items: center; gap: 4px;">
                    <span>Vecchio codice</span>
                    <p-sortIcon field="scheda.vecchioCodiceUmvs"></p-sortIcon>
                  </div>
                </th>
                <th style="width: 20%">Ente Esecutore</th>
                <th style="width: 15%">Bacino</th>
                <th style="width: 15%">Comune</th>
                <th style="width: 5%" style="text-align: center;" >Stato</th>
                <th style="width: 5%" style="text-align: center;" >Tipo</th>
                <th style="width: 2%" style="text-align: center;" >Prior.</th>

                <th style="width: 120px; min-width: 120px; max-width: 120px;" class="text-center" pSortableColumn="importoRichiesto">
                  <div style="display: flex; justify-content: center; align-items: center; gap: 4px;">
                    <span>Importo Richiesto</span>
                    <p-sortIcon field="importoRichiesto"></p-sortIcon>
                  </div>
                </th>
                <th style="width: 120px; min-width: 120px; max-width: 120px;" class="text-center" pSortableColumn="importoRimodulato">
                  <div style="display: flex; justify-content: center; align-items: center; gap: 4px;">
                    <span>Importo Rimodulato</span>
                    <p-sortIcon field="importoRimodulato"></p-sortIcon>
                  </div>
                </th>
                <th style="width: 120px; min-width: 120px; max-width: 120px;" class="text-center" pSortableColumn="importoFinanziato">
                  <div style="display: flex; justify-content: center; align-items: center; gap: 4px;">
                    <span>Importo Finanziato</span>
                    <p-sortIcon field="importoFinanziato"></p-sortIcon>
                  </div>
                </th>
                <th style="width: 120px; min-width: 120px; max-width: 120px;" class="text-center" pSortableColumn="importoRendicontato">
                  <div style="display: flex; justify-content: center; align-items: center; gap: 4px;">
                    <span>Importo Rendicontato</span>
                    <p-sortIcon field="importoRendicontato"></p-sortIcon>
                  </div>
                </th>
                <th style="width: 120px; min-width: 120px; max-width: 120px;" class="text-center" pSortableColumn="importoLiquidato">
                  <div style="display: flex; justify-content: center; align-items: center; gap: 4px;">
                    <span>Importo Liquidato</span>
                    <p-sortIcon field="importoLiquidato"></p-sortIcon>
                  </div>
                </th>
              </tr>
            </ng-template>

            <!-- Corpo della tabella -->
            <ng-template pTemplate="body" let-intervento>
              <tr>
                <td style="width: 2%" class="text-center">
                  <button *ngIf="checkIfSameEnteEsecutore(intervento)"
                    pButton type="button" style="color:rgb(39, 128, 15)"
                    icon="pi pi-ellipsis-v" class="p-button-rounded p-button-text small-icon"
                    (click)="openCaricaAzioni($event,intervento)">
                  </button>
                </td>
                <td style="width: 3%">
                  <span class="badge"
                  [ngStyle]="{
                    'background-color': stiliService.getColoreAnnoRichiesta(intervento.richiesta),
                    'color': '#ffffff',
                    'padding': '2px 4px',
                    'border-radius': '4px',
                    'display': 'block',
                    'text-align': 'center',
                    'width': 'fit-content',
                    'margin': '0 auto',
                    'font-size': '10px'
                  }" pTooltip="{{ intervento.note | uppercase }}" tooltipPosition="top">
                    {{ intervento.richiesta.anno }}
                  </span>
                </td>
                <td style="width: 6%">
                  <div class="codice-scheda-badge">
                    <span class="codice-scheda-value">
                      {{ intervento.scheda.codice | uppercase}}
                    </span>
                  </div>
                </td>
                <td style="width: 4%">
                  <div *ngIf="intervento.scheda.vecchioCodiceUmvs" class="vecchio-codice-scheda-badge">
                    <span *ngIf="intervento.scheda.vecchioCodiceUmvs" class="codice-scheda-value">
                      {{ intervento.scheda.vecchioCodiceUmvs | uppercase}}
                    </span>
                  </div>
                </td>
                <td style="width: 25%">
                  <div class="ente-badge" [ngClass]="'ente-badge-' + intervento.richiesta.enteEsecutore.categoria?.descrizione.toLowerCase()" style="margin: 0">
                    <span class="ente-value">{{ intervento.richiesta.enteEsecutore.label | uppercase }}</span>
                  </div>
                </td>
                <td style="width: 20%">
                  <div class="bacino-badge" style="margin: 0">
                    <span class="bacino-value">{{ intervento.scheda.bacino.denominazione | uppercase }}</span>
                  </div>
                </td>
                <td style="width: 15%">
                  <div class="comune-badge" style="margin: 0">
                    <span class="comune-value">{{ intervento.scheda.comune?.denominazione | uppercase }}</span>
                  </div>
                </td>

                <td style="width: 5%" class="text-center">
                  <span
                    class="material-symbols-outlined small-icon"
                    style="display: flex; justify-content: center; align-items: center;"
                    [ngClass]="stiliService.getIconaStatoIntervento(intervento.stato.id)"
                    [ngStyle]="{
                      'color': stiliService.geColoreStatoIntervento(intervento.stato.id)
                    }"
                    [pTooltip]="intervento.stato.descrizione | uppercase" tooltipPosition="top">
                    {{ stiliService.getIconaStatoIntervento(intervento.stato.id) }}
                  </span>
                </td>
                <td style="width: 5%" style="text-align: center;" >
                  <div [ngStyle]="stiliService.getStileTipoIntervento(intervento.tipoIntervento.id)" pTooltip="{{ intervento.tipoIntervento.descrizione }}" tooltipPosition="top">
                    <i class="material-icons stato-badge-icon">
                      {{ stiliService.getIconaTipoIntervento(intervento.tipoIntervento.id) }}
                    </i>
                  </div>
                </td>
                <td style="width: 2%" style="text-align: center;" >
                  <div [ngStyle]="stiliService.getStilePrioritaIntervento(intervento.priorita)" pTooltip="{{ stiliService.getDescrizionePriorita(intervento.priorita) }}" tooltipPosition="top">
                    <i class="material-icons" style="font-size: 18px;">
                      {{ stiliService.getIconaPrioritaIntervento(intervento.priorita) }}
                    </i>
                  </div>

                </td>

                <td style="width: 120px; min-width: 120px; max-width: 120px;" class="text-center">
                  <div *ngIf="this.isInterventoDellEnte(intervento) && intervento.importoRichiesto" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #3c6a76; border: 1px solid #1d7572;">
                    <span class="chip-label" style="font-size: 12px; color: #ffffff;">{{ intervento.importoRichiesto ? (intervento.importoRichiesto | currency:'EUR':'':'1.2-2':'it-IT') : '-' }}</span>
                    <!-- <i class="pi pi-euro" style="font-size: 13px; color: #fffffe; margin-left: 6px;"></i> -->
                  </div>
                </td>
                <td style="width: 120px; min-width: 120px; max-width: 120px;" class="text-center">
                  <div *ngIf="this.isInterventoDellEnte(intervento) && intervento.importoRimodulato" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #779f3a; border: 1px solid #496323;">
                    <span class="chip-label" style="font-size: 12px; color: #ffffff;">{{ intervento.importoRimodulato ? (intervento.importoRimodulato | currency:'EUR':'':'1.2-2':'it-IT') : '-' }}</span>
                    <!-- <i class="pi pi-euro" style="font-size: 13px; color: #fffffe; margin-left: 6px;"></i> -->
                  </div>
                </td>
                <td style="width: 120px; min-width: 120px; max-width: 120px;" class="text-center">
                  <div *ngIf="this.isInterventoDellEnte(intervento) && intervento.importoFinanziato" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #489478; border: 1px solid #1d7572;">
                    <span class="chip-label" style="font-size: 12px; color: #ffffff;">{{ intervento.importoFinanziato ? (intervento.importoFinanziato | currency:'EUR':'':'1.2-2':'it-IT') : '-' }}</span>
                    <!-- <i class="pi pi-euro" style="font-size: 13px; color: #fffffe; margin-left: 6px;"></i> -->
                  </div>
                </td>
                <td style="width: 120px; min-width: 120px; max-width: 120px;" class="text-center">
                  <div
                    *ngIf="this.isInterventoDellEnte(intervento) && intervento.importoRendicontato"
                    class="custom-chip chip-rendicontazione"
                    [ngClass]="{
                      'chip-rendicontazione-parziale': isRendicontazioneParziale(intervento),
                      'chip-rendicontazione-completa': isRendicontazioneCompleta(intervento)
                    }"
                    pTooltip="{{ getRendicontazioneTooltip(intervento) }}"
                    tooltipPosition="top"
                    style="display: flex; margin: 0 auto; width: fit-content;"
                  >
                    <span class="chip-label importo-label">
                      {{ intervento.importoRendicontato ? (intervento.importoRendicontato | currency:'EUR':'':'1.2-2':'it-IT') : '-' }}
                    </span>
                    <!-- Indicatore di stato con pallino colorato (momentaneamente disabilitato)
                    <span class="chip-rendicontazione-badge">
                      <span class="chip-rendicontazione-dot"></span>
                    </span>
                    -->
                    <!-- <i class="pi pi-euro" style="font-size: 13px; margin-left: 6px;"></i> -->
                  </div>
                </td>
                <td style="width: 120px; min-width: 120px; max-width: 120px;" class="text-center">
                  <div style="display: flex; justify-content: center; align-items: center;">
                    <button
                      *ngIf="this.isInterventoDellEnte(intervento) && intervento.importoLiquidato"
                      pButton
                      type="button"
                      class="p-button-text p-button-sm custom-chip-button"
                      style="padding: 0; border: none; background: transparent;"
                      (click)="storicoLiquidazioniComponent.show(intervento)"
                      pTooltip="Visualizza storico liquidazioni"
                      tooltipPosition="top"
                    >
                      <div
                        class="custom-chip pmo-importo-liquidato-chip pmo-importo-liquidato-chip--row"
                        [ngClass]="{
                          'pmo-importo-liquidato-chip--liquidato': isInterventoLiquidato(intervento),
                          'pmo-importo-liquidato-chip--warning': !isInterventoLiquidato(intervento)
                        }"
                      >
                        <span class="chip-label">
                          {{ intervento.importoLiquidato ? (intervento.importoLiquidato | currency:'EUR':'':'1.2-2':'it-IT') : '-' }}
                        </span>
                      </div>
                    </button>
                  </div>
                </td>
              </tr>
            </ng-template>

            <!-- Footer della tabella con le somme -->
            <ng-template pTemplate="footer">
              <tr style="background-color: #f8f9fa; border-top: 2px solid #dee2e6;">
                <td colspan="10" style="text-align: right; font-weight: 600; font-size: 12px; padding: 15px 10px;">TOTALI:</td>
                <td class="text-center" style="padding: 15px 10px;">
                  <div class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #3c6a76; border: 2px solid #1d7572; padding: 8px 12px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                    <span class="chip-label" style="font-size: 12px; font-weight: 600; color: #ffffff;">{{ getTotaleImportoRichiesto() | currency:'EUR':'':'1.2-2':'it-IT' }}</span>
                    <!-- <i class="pi pi-euro" style="font-size: 12px; color: #fffffe; margin-left: 8px;"></i> -->
                  </div>
                </td>
                <td class="text-center" style="padding: 15px 10px;">
                  <div *ngIf="getTotaleImportoRimodulato()" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #779f3a; border: 2px solid #496323; padding: 8px 12px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                    <span class="chip-label" style="font-size: 12px; font-weight: 600; color: #ffffff;">{{ getTotaleImportoRimodulato() | currency:'EUR':'':'1.2-2':'it-IT' }}</span>
                    <!-- <i class="pi pi-euro" style="font-size: 12px; color: #fffffe; margin-left: 8px;"></i> -->
                  </div>
                </td>
                <td class="text-center" style="padding: 15px 10px;">
                  <div *ngIf="getTotaleImportoFinanziato()" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #489478; border: 2px solid #1d7572; padding: 8px 12px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                    <span class="chip-label" style="font-size: 12px; font-weight: 600; color: #ffffff;">{{ getTotaleImportoFinanziato() | currency:'EUR':'':'1.2-2':'it-IT' }}</span>
                    <!-- <i class="pi pi-euro" style="font-size: 12px; color: #fffffe; margin-left: 8px;"></i> -->
                  </div>
                </td>
                <td class="text-center" style="padding: 15px 10px;">
                  <div *ngIf="getTotaleImportoRendicontato()" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #53923d; border: 2px solid #1d7572; padding: 8px 12px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                    <span class="chip-label" style="font-size: 12px; font-weight: 600; color: #ffffff;">{{ getTotaleImportoRendicontato() | currency:'EUR':'':'1.2-2':'it-IT' }}</span>
                    <!-- <i class="pi pi-euro" style="font-size: 12px; color: #fffffe; margin-left: 8px;"></i> -->
                  </div>
                </td>
                <td class="text-center" style="padding: 15px 10px;">
                  <div class="custom-chip pmo-importo-liquidato-chip pmo-importo-liquidato-chip--totale">
                    <span class="chip-label">{{ getTotaleImportoLiquidato() | currency:'EUR':'':'1.2-2':'it-IT' }}</span>
                    <!-- <i class="pi pi-euro" style="font-size: 12px; color: #be185d; margin-left: 8px;"></i> -->
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div *ngIf="isDownloading" class="loading-overlay" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255,255,255,0.9); display: flex; justify-content: center; align-items: center; z-index: 1000;">
          <ng-lottie [options]="options" width="300px" height="300px"></ng-lottie>
        </div>
    </p-tabPanel>

    <!-- Tab Mappa -->
    <p-tabPanel header="Mappa" leftIcon="pi pi-map-marker">
      <div class="map-container">
        <!-- Toggle per filtrare interventi nella mappa -->
        <div *ngIf="isEnteEsecutore" class="filter-toggle-container" style="margin-bottom: 1rem; display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem; background: #f8f9fa; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
          <div class="toggle-switch" style="margin: 0;">
            <input type="checkbox" id="toggleFilterMap" [(ngModel)]="showOnlyMyInterventi" (change)="onToggleFilter()" class="toggle-input">
            <label for="toggleFilterMap" class="toggle-label">
              <span class="toggle-inner"></span>
              <span class="toggle-switch"></span>
            </label>
          </div>
          <span style="font-size: 14px; color: #495057; font-weight: 500;">Escludi gli interventi di altri enti</span>
        </div>

        <div #map class="map-view"></div>
      </div>
    </p-tabPanel>
  </p-tabView>
  </div>

  <!-- Menu azioni -->
  <p-tieredMenu #azioniMenuTiered [model]="menuAzioniItems" [popup]="true"></p-tieredMenu>

  <p-toast position="top-right"></p-toast>

  <!-- Nuovo Intervento Dialog -->
  <app-nuovo-intervento [isEnteEsecutore]="isEnteEsecutore" (interventoCreato)="onInterventoCreato($event)"></app-nuovo-intervento>
  <app-rimodula-richiesto
    [(visible)]="mostraRimodulaRichiesta"
    [intervento]="interventoRimodulaRichiesta"
    (rimodulato)="onRimodulaRichiesta($event)">
  </app-rimodula-richiesto>
   <app-conferma-finanziamento
    [(visible)]="mostraConfermaFinanziamento"
    [intervento]="interventoConfermaFinanziamento"
    (finanziato)="onConfermaFinanziamento($event)">
  </app-conferma-finanziamento>
  <app-rendiconta
    [(visible)]="mostraRendiconta"
    [intervento]="interventoRendiconta"
    (rendicontato)="onRendiconta($event)">
  </app-rendiconta>
  <app-determina
    [(visible)]="mostraComunicaDetermina"
    [intervento]="interventoComunicaDetermina"
    (determinato)="onComunicaDetermina($event)">
  </app-determina>
  <app-mappa-intervento
    [(visible)]="showMappaIntervento"
    [titolo]="mappaInterventoTitolo"
    [scheda]="schedaIntervento"
    [datiGeoJSON]="selectedFeatureGeoJSON">
  </app-mappa-intervento>

  <app-liquidazione-intervento
    [(visible)]="mostraLiquidazione"
    [intervento]="interventoLiquidazione"
    (liquidato)="caricaInterventi()">
  </app-liquidazione-intervento>

  <app-riproponi-intervento
    *ngIf="interventoSelezionato !== null && richiestaSelezionata !== null"
    [intervento]="interventoSelezionato"
    [richiesta]="richiestaSelezionata"
    (conferma)="onRiproposizioneConfermata($event)">
  </app-riproponi-intervento>

  <app-elimina-intervento
    [(visible)]="showConfermaCancellazione"
    [intervento]="interventoDaEliminare"
    (onConfirm)="confermaEliminazione()">
  </app-elimina-intervento>

  <app-storico-intervento #storicoInterventoComponent
   [(visible)]="showStoricoIntervento"
   [intervento]="interventoSelezionato"
  ></app-storico-intervento>

  <app-storico-liquidazioni
    #storicoLiquidazioniComponent
    [(visible)]="showStoricoLiquidazioni"
    [intervento]="interventoSelezionato"
  ></app-storico-liquidazioni>

  <app-stato-rendicontazione
   [isEnteEsecutore]="isEnteEsecutore"
   (rendicontazioneEliminata)="caricaInterventi()"
   (interventiAggiornati)="caricaInterventi()"
  ></app-stato-rendicontazione>

  <app-modifica-intervento
    [isEnteEsecutore]="isEnteEsecutore"
    (interventoModificato)="onInterventoModificato($event)"
    [intervento]="interventoSelezionato"
    >
  </app-modifica-intervento>

  <app-assegna-massivamente-determine
    [(visible)]="mostraAssegnaMassivamenteDetermine"
    [richiestaPreselezionata]="null"
    (determineAssegnate)="onDetermineAssegnate()">
  </app-assegna-massivamente-determine>

  <app-modifica-note-intervento
    [(visible)]="showModificaNoteIntervento"
    [intervento]="interventoSelezionato"
    (noteModificate)="onNoteModificate()">
  </app-modifica-note-intervento>
</div>
